export default __webpack_public_path__ + "static/media/calendar.b0a713cd.svg";